module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00697.a0b8fb2b.jpg";